import React from "react";
// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import TextField from "@limitless/modern/inputs/text-field/TextField";
import Button from "@limitless/modern/inputs/button/Button";
import { PaymentForm } from "@limitless/expert";
import { useTranslation } from "@limitless/common/hooks";
import PaypalVerification from "./paypal-verification/PaypalVerification";
import AnimationWrapper from "@limitless/modern/components/animation-wrapper/AnimationWrapper";
import { PAYPAL_WAITTING_FOR_CODE, PAYPAL_PROCESS_INITIATED } from "@limitless/expert";

const Payment = () => {
    const { t } = useTranslation();

    const signupPayPal = () => window.open(t("https://www.paypal.com/signin"), "_blank");

    return (
        <Grid mt={theme => theme.spacing(2)} sx={{ maxWidth: "540px" }}>
            <PaymentForm>
                {({
                    paypalAccount,
                    fieldErrors,
                    isFormInvalid,
                    onPaypalAccountChange,
                    onFormSubmit,
                    loading,
                    verificationStatus,
                    onSubmitPayPalVerificationDetail,
                    closePayPalVerification,
                    verifyPaypalError,
                    clearVerifyPaypalError,
                    isEditPaypalAddress,
                    setIsEditPaypalAddress,
                    profile,
                    isSuccess,
                    setIsSuccess
                }) => {
                    return (
                        <>
                            <AnimationWrapper showAnimation>
                                <Typography variant="body2" sx={{ color: theme => theme.palette.grey[4] }}>
                                    {paypalAccount.verificationStage === 0 && profile?.paypalAccount
                                        ? isSuccess
                                            ? "Your PayPal address has now been updated successfully"
                                            : "In order to change your PayPal address, you must first verify your registered email address"
                                        : paypalAccount.verificationStage === 1
                                        ? verificationStatus.state === PAYPAL_WAITTING_FOR_CODE ||
                                          verificationStatus.state === PAYPAL_PROCESS_INITIATED
                                            ? "We need you to verify your new PayPal address"
                                            : "Please update your PayPal address below"
                                        : "In order to withdraw your rewards, please ensure that you have correctly entered your PayPal email address below. All withdrawals are subject to a 1.96% PayPal fee."}
                                </Typography>
                            </AnimationWrapper>
                            {!verificationStatus.isOpen ? (
                                <AnimationWrapper showAnimation>
                                    <Grid mt={theme => theme.spacing(2)} item xs={6}>
                                        <TextField
                                            label={"PayPal Address"}
                                            placeholder={"Type your PayPal address"}
                                            id="paypalInputField"
                                            onChange={event => onPaypalAccountChange(event.target.value)}
                                            value={paypalAccount.value}
                                            error={fieldErrors.paypalAccount ? true : false}
                                            errorText={fieldErrors.paypalAccount}
                                            required
                                            disabled={!isEditPaypalAddress}
                                            endAdornment={
                                                !isEditPaypalAddress && (
                                                    <Typography
                                                        color="primary"
                                                        variant="body"
                                                        sx={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            onFormSubmit();
                                                            onSubmitPayPalVerificationDetail({
                                                                paypalAccount: profile.paypalAccount
                                                                    ? profile.email
                                                                    : paypalAccount.value
                                                            });
                                                        }}
                                                    >
                                                        Edit
                                                    </Typography>
                                                )
                                            }
                                        />
                                        {isEditPaypalAddress &&
                                            verificationStatus.state === "paypalVerificationNotRequired" && (
                                                <Grid mt={theme => theme.spacing(3)} item xs={9}>
                                                    <Button
                                                        id="savePaymentButton"
                                                        variant="contained"
                                                        disabled={loading || isFormInvalid}
                                                        onClick={() => {
                                                            onFormSubmit(res => {
                                                                if (!res?.hasError) {
                                                                    onSubmitPayPalVerificationDetail({
                                                                        paypalAccount: paypalAccount.value
                                                                    });
                                                                }
                                                            });
                                                        }}
                                                        fullWidth
                                                    >
                                                        Save Changes
                                                    </Button>
                                                    <Grid sx={{ textAlign: "center" }}>
                                                        <Grid mt={theme => theme.spacing(1.5)}>
                                                            <Typography
                                                                variant="caption"
                                                                sx={{ color: theme => theme.palette.grey[4] }}
                                                            >
                                                                {"Don't have a PayPal account?"}
                                                            </Typography>
                                                        </Grid>
                                                        <Typography
                                                            onClick={signupPayPal}
                                                            component="span"
                                                            variant="caption"
                                                            color="primary"
                                                            sx={{ cursor: "pointer" }}
                                                        >
                                                            {"Click here to sign up"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            )}
                                    </Grid>
                                </AnimationWrapper>
                            ) : (
                                <PaypalVerification
                                    clearVerifyPaypalError={clearVerifyPaypalError}
                                    verifyPaypalError={verifyPaypalError}
                                    paypalAccount={paypalAccount}
                                    status={verificationStatus}
                                    onVerifyClick={onSubmitPayPalVerificationDetail}
                                    onCancel={closePayPalVerification}
                                    setIsEditPaypalAddress={setIsEditPaypalAddress}
                                    profile={profile}
                                    setIsSuccess={setIsSuccess}
                                    isSuccess={isSuccess}
                                />
                            )}
                        </>
                    );
                }}
            </PaymentForm>
        </Grid>
    );
};

export default Payment;
